
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none !important","stroke":"none !important","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 3s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V3zM11 3s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V3z","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"}})])
          )
        }
      }
    